export class Throttle {

  private time = new Date;

  private get needsToThrottle(): boolean {
    return (new Date()).getTime() - this.time.getTime() < this.interval;
  }

  constructor(
    public readonly interval: number // ms
  ) {}

  execute(action: () => void): void {
    if (this.needsToThrottle) {
      return;
    }

    action();

    this.reset();
  }

  private reset() {
    this.time = new Date;
  }

}
